import React from 'react';
import { SELECT } from './uiTokens';
import type { SelectProps } from './types/UIProps';

export type { SelectProps };

export function Select({ className = '', children, ...rest }: SelectProps): React.ReactElement {
  return (
    <select className={`${SELECT} ${className}`.trim()} {...rest}>
      {children}
    </select>
  );
}
